
const FEATURES = [
  { key: 'Perf', icon: ['fal', 'lightbulb-on'] },
  { key: 'Reliability', icon: ['fal', 'shield-check'] },
  { key: 'Reactivity', icon: ['fal', 'bolt'] },
  { key: 'Efficiency', icon: ['fal', 'car-battery'] },
]

export default {
  name: 'HomeSeoStory',
  props: {
    links: {
      type: Object,
      required: true,
    },
  },
  computed: {
    features() {
      return FEATURES.map(feature => ({
        ...feature,
        title: this.$t(`pages.index.seoContent.card1${feature.key}`)
          .replace(/\s*:\s*$/, '')
          .trim(),
        text: this.$t(`pages.index.seoContent.card1${feature.key}Desc`),
      }))
    },
  },
}
